// File: src/App.jsx
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import * as Icons from 'lucide-react';
import { 
  Search, Menu, X, User, ChevronLeft, ChevronDown,
  Briefcase, Coffee, Layers, LogOut, Key, Loader2
} from 'lucide-react';

// توجه: داده‌های استاتیک حذف شده‌اند
import MainContent from './Subprogram/Products'; 
import ProductDetail from './Subprogram/ProductDetail'; 
import NewsAndReviews from './Subprogram/NewsAndReviews';
import AdminPanel from './Subprogram/AdminPanel';
import Footer from './Subprogram/Footer'; 
import Login from './Subprogram/Login'; 

// --- Components ---

const UserProfileModal = ({ isOpen, onClose, user, onLogout }) => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [status, setStatus] = useState({ type: '', msg: '' });
  const [loading, setLoading] = useState(false);

  if (!isOpen || !user) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      setStatus({ type: 'error', msg: 'رمز عبور جدید و تکرار آن یکسان نیستند' });
      return;
    }
    setLoading(true);
    setStatus({ type: '', msg: '' });

    try {
      const res = await axios.post('https://free3dmax.ir/api/users.php', {
        action: 'change_password', user_id: user.id, current_password: currentPassword, new_password: newPassword
      });
      if (res.data.success) {
        setStatus({ type: 'success', msg: res.data.message });
        setTimeout(() => { onClose(); setCurrentPassword(''); setNewPassword(''); setConfirmPassword(''); setStatus({ type: '', msg: '' }); }, 2000);
      } else { setStatus({ type: 'error', msg: res.data.error }); }
    } catch (error) { setStatus({ type: 'error', msg: 'خطا در ارتباط با سرور' }); } finally { setLoading(false); }
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-slate-900/60 backdrop-blur-sm" onClick={onClose}></div>
      <div className="relative bg-white w-full max-w-sm rounded-3xl shadow-2xl overflow-hidden animate-fade-in-up">
        <div className="bg-slate-900 p-4 flex justify-between items-center text-white">
          <h3 className="font-bold flex items-center gap-2"><User size={18}/> حساب کاربری</h3>
          <button onClick={onClose} className="hover:text-red-400 transition-colors"><X size={20}/></button>
        </div>
        <div className="p-6">
            <div className="flex items-center gap-4 mb-6 bg-slate-50 p-4 rounded-2xl border border-slate-100">
                <div className="w-14 h-14 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center font-black text-xl shadow-inner shrink-0">
                    {user.full_name ? user.full_name.charAt(0) : 'U'}
                </div>
                <div className="overflow-hidden">
                    <div className="font-bold text-slate-800 text-lg truncate">{user.full_name || 'کاربر گرامی'}</div>
                    <div className="text-xs text-slate-500 dir-ltr text-right truncate mt-1">{user.email}</div>
                </div>
            </div>
            <div className="border-t border-slate-100 pt-5">
                <h4 className="font-bold text-sm text-slate-700 mb-4 flex items-center gap-2"><Key size={16} className="text-blue-500"/> تغییر رمز عبور</h4>
                <form onSubmit={handleSubmit} className="space-y-3">
                  {status.msg && <div className={`p-2 rounded-xl text-xs font-bold text-center ${status.type === 'error' ? 'bg-red-50 text-red-500 border border-red-100' : 'bg-green-50 text-green-600 border border-green-100'}`}>{status.msg}</div>}
                  <div><input required type="password" value={currentPassword} onChange={e => setCurrentPassword(e.target.value)} className="w-full bg-slate-50 border border-slate-200 rounded-xl p-3 text-sm outline-none focus:border-blue-500 focus:bg-white transition-all dir-ltr text-left" placeholder="رمز عبور فعلی (یا موقت)" /></div>
                  <div className="grid grid-cols-2 gap-2">
                      <input required type="password" value={newPassword} onChange={e => setNewPassword(e.target.value)} className="w-full bg-slate-50 border border-slate-200 rounded-xl p-3 text-sm outline-none focus:border-blue-500 focus:bg-white transition-all dir-ltr text-left" placeholder="رمز جدید" />
                      <input required type="password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} className="w-full bg-slate-50 border border-slate-200 rounded-xl p-3 text-sm outline-none focus:border-blue-500 focus:bg-white transition-all dir-ltr text-left" placeholder="تکرار رمز" />
                  </div>
                  <button type="submit" disabled={loading} className="w-full bg-blue-600 text-white py-3 rounded-xl font-bold shadow-lg shadow-blue-600/20 hover:bg-blue-700 transition-colors mt-2 flex justify-center items-center gap-2">
                    {loading ? <Loader2 className="animate-spin" size={18} /> : 'ثبت رمز جدید'}
                  </button>
                </form>
            </div>
            <div className="border-t border-slate-100 mt-6 pt-5">
                <button onClick={() => { onLogout(); onClose(); }} className="w-full text-red-500 bg-red-50 hover:bg-red-500 hover:text-white py-3 rounded-xl font-bold transition-all flex items-center justify-center gap-2">
                    <LogOut size={18} /> خروج از حساب کاربری
                </button>
            </div>
        </div>
      </div>
    </div>
  );
};

const MobileMenu = ({ isOpen, onClose, activePage, onNavigate, onOpenAuth, scrollToModels, user, onOpenUserProfile }) => {
  return (
      <div className={`fixed inset-0 bg-slate-900/80 backdrop-blur-md z-[60] transition-opacity duration-300 ${isOpen ? 'opacity-100 visible' : 'opacity-0 invisible'}`} onClick={onClose}>
        <div className={`absolute top-0 right-0 w-4/5 max-w-xs h-full bg-white shadow-2xl transition-transform duration-300 transform flex flex-col ${isOpen ? 'translate-x-0' : 'translate-x-full'}`} onClick={e => e.stopPropagation()}>
          <div className="p-6 flex justify-between items-center border-b border-slate-100 bg-white flex-none">
            <span className="font-bold text-lg text-slate-900">منوی اصلی</span>
            <button onClick={onClose} className="text-slate-500 hover:text-red-500 bg-slate-50 p-2 rounded-full transition-colors"><X size={24} /></button>
          </div>
          <div className="p-4 flex flex-col gap-3 bg-white flex-1 overflow-y-auto">
            <button onClick={() => {onNavigate('home'); onClose();}} className={`${activePage === 'home' ? 'bg-blue-50 text-blue-600 shadow-sm' : 'bg-slate-50 text-slate-700 hover:bg-slate-100'} p-4 rounded-xl font-bold text-base flex items-center justify-between transition-all`}>
                خانه <ChevronLeft size={18} className={activePage === 'home' ? 'text-blue-500' : 'text-slate-400'} />
            </button>
            <button onClick={() => {scrollToModels(); onClose();}} className={`${activePage === 'models' ? 'bg-pink-50 text-pink-600 shadow-sm' : 'bg-slate-50 text-slate-700 hover:bg-slate-100'} p-4 rounded-xl font-bold text-base flex items-center justify-between transition-all`}>
                آبجکت‌های سه‌بعدی <ChevronLeft size={18} className={activePage === 'models' ? 'text-pink-500' : 'text-slate-400'} />
            </button>
            <button onClick={() => {onNavigate('news'); onClose();}} className={`${activePage === 'news' ? 'bg-purple-50 text-purple-600 shadow-sm' : 'bg-slate-50 text-slate-700 hover:bg-slate-100'} p-4 rounded-xl font-bold text-base flex items-center justify-between transition-all`}>
                اخبار و گفتگو <ChevronLeft size={18} className={activePage === 'news' ? 'text-purple-500' : 'text-slate-400'} />
            </button>
            <button onClick={() => {onNavigate('about'); onClose();}} className={`${activePage === 'about' ? 'bg-amber-50 text-amber-600 shadow-sm' : 'bg-slate-50 text-slate-700 hover:bg-slate-100'} p-4 rounded-xl font-bold text-base flex items-center justify-between transition-all`}>
                معرفی ما <ChevronLeft size={18} className={activePage === 'about' ? 'text-amber-500' : 'text-slate-400'} />
            </button>
            <div className="mt-auto pt-6 pb-2 border-t border-slate-100">
                 {user ? (
                   <button onClick={() => {onOpenUserProfile(); onClose();}} className="bg-slate-50 w-full p-4 rounded-2xl flex items-center justify-between hover:bg-slate-100 transition-colors border border-slate-100">
                      <div className="flex items-center gap-3">
                         <div className="w-10 h-10 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center font-bold">{user.full_name ? user.full_name.charAt(0) : 'U'}</div>
                         <div className="flex flex-col text-right">
                             <span className="font-bold text-sm text-slate-800">{user.full_name || 'کاربر'}</span>
                             <span className="text-[10px] text-slate-500 mt-0.5">مشاهده حساب کاربری</span>
                         </div>
                      </div>
                      <ChevronLeft size={18} className="text-slate-400" />
                   </button>
                 ) : (
                    <button onClick={() => {onOpenAuth(); onClose();}} className="bg-slate-900 text-white w-full py-4 rounded-xl font-bold shadow-lg shadow-slate-900/20 flex items-center justify-center gap-2 hover:bg-slate-800 transition-colors active:scale-95">
                        <User size={20} /> ورود / ثبت نام
                    </button>
                 )}
            </div>
          </div>
        </div>
      </div>
  );
};

const Navbar = ({ categories, onOpenAuth, activePage, onNavigate, setMobileMenuOpen, scrollToModels, user, onOpenUserProfile, selectedCategory, setSelectedCategory, searchQuery, setSearchQuery }) => {
  const [isDesktopMenuOpen, setIsDesktopMenuOpen] = useState(false);

  const handleNavClick = (page) => {
    onNavigate(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
    if (page === 'models') scrollToModels();
  };

  const getButtonClass = (pageName, color = 'blue') => {
    const isActive = activePage === pageName;
    const baseClass = "px-6 py-2 rounded-full text-sm font-bold transition-all duration-300 transform hover:-translate-y-0.5 shadow-sm border border-slate-200/40";
    if (isActive) {
      if(color === 'purple') return `${baseClass} bg-gradient-to-r from-purple-600 to-pink-500 text-white shadow-purple-500/30 border-none`;
      if(color === 'amber') return `${baseClass} bg-gradient-to-r from-amber-500 to-orange-400 text-white shadow-amber-500/30 border-none`;
      if(color === 'pink') return `${baseClass} bg-gradient-to-r from-pink-400 to-pink-600 text-white shadow-pink-500/30 border-none`;
      return `${baseClass} bg-gradient-to-r from-blue-600 to-cyan-500 text-white shadow-blue-500/30 border-none`;
    }
    return `${baseClass} bg-white text-slate-600 hover:bg-slate-50 hover:text-${color}-600`;
  };

  return (
    <nav className="fixed top-0 w-full z-50 bg-white/95 backdrop-blur-md transition-all duration-300 shadow-sm flex flex-col">
      <div className="container mx-auto px-4 py-3 flex items-center justify-between relative">
        <div className="flex items-center cursor-pointer z-10" onClick={() => handleNavClick('home')}>
          <div className="w-14 h-14 md:w-16 md:h-16 bg-blue-600 rounded-2xl flex items-center justify-center text-white shadow-lg shadow-blue-600/20 overflow-hidden shrink-0">
             <img src="/Banner/logo.png" alt="Logo" className="w-full h-full object-cover" />
          </div>
        </div>

        <div className="absolute left-1/2 transform -translate-x-1/2 flex flex-col items-center justify-center cursor-pointer w-max" onClick={() => handleNavClick('home')}>
            <h1 className="text-xl md:text-3xl font-black italic text-slate-800 tracking-tight">
                FREE<span className="text-yellow-500">3D</span>MAX<span className="text-red-600">.IR</span>
            </h1>
            <p className="text-[9px] md:text-[11px] text-slate-500 font-bold tracking-[0.15em] md:tracking-[0.25em] mt-0.5">ARCHITECTURAL ASSETS</p>
        </div>

        <div className="flex items-center gap-2 md:gap-3 z-10">
          {user ? (
             <button onClick={onOpenUserProfile} className="hidden md:flex items-center gap-2 bg-slate-50 pr-4 pl-2 py-1.5 rounded-full border border-slate-200 hover:bg-slate-100 hover:border-blue-200 transition-all shadow-sm group">
                <span className="text-sm font-bold text-slate-700 truncate max-w-[120px] ml-2 group-hover:text-blue-600 transition-colors">{user.full_name}</span>
                <div className="bg-white w-8 h-8 rounded-full text-blue-500 flex items-center justify-center shadow-sm border border-slate-100 font-bold"><User size={16} /></div>
             </button>
          ) : (
            <button onClick={onOpenAuth} className="hidden md:flex items-center gap-2 bg-slate-900 text-white px-5 py-2.5 rounded-full text-sm font-bold hover:bg-slate-800 transition-all shadow-lg shadow-slate-900/10 hover:shadow-slate-900/20 active:scale-95">
                <User size={18} /><span>ورود / عضویت</span>
            </button>
          )}
          <button className="lg:hidden p-2 text-slate-800" onClick={() => setMobileMenuOpen(true)}><Menu size={24} /></button>
        </div>
      </div>

      <div className="w-full py-1" dir="ltr">
         <div className="w-full h-[18px]" style={{ background: 'linear-gradient(60deg, #f97316 0%, #f97316 calc(80% - 15px), transparent calc(80% - 15px), transparent calc(80% + 15px), #6AC5C7 calc(80% + 15px), #6AC5C7 100%)' }}></div>
      </div>

      <div className="w-full bg-[#eeeeee] border-b border-slate-200 shadow-inner hidden lg:block relative z-40">
         <div className="container mx-auto px-4 py-2 flex items-center justify-between">
            
            {/* منوی دسته‌بندی دسکتاپ (تبدیل به گرید داینامیک) */}
            <div className="relative" onMouseEnter={() => setIsDesktopMenuOpen(true)} onMouseLeave={() => setIsDesktopMenuOpen(false)}>
                <button className="flex items-center gap-2 px-5 py-2.5 bg-white text-slate-800 rounded-xl font-bold shadow-sm transition-all hover:bg-slate-50 border border-slate-200 text-sm">
                    <Menu size={18} className="text-blue-600" />
                    <span>دسته‌بندی‌ها</span>
                    <ChevronDown size={14} className={`transition-transform duration-300 ${isDesktopMenuOpen ? 'rotate-180' : ''}`} />
                </button>
                
                <div className={`absolute top-full right-0 mt-2 w-[550px] bg-white rounded-3xl shadow-xl border border-slate-200 overflow-hidden transition-all duration-300 origin-top-right ${isDesktopMenuOpen ? 'opacity-100 scale-100 visible' : 'opacity-0 scale-95 invisible'}`}>
                    <div className="p-4 grid grid-cols-2 gap-2 max-h-[450px] overflow-y-auto custom-scrollbar">
                        <button
                            onClick={() => { setSelectedCategory('all'); setIsDesktopMenuOpen(false); scrollToModels(); }}
                            className={`flex items-center gap-3 p-3 rounded-xl transition-all border border-transparent ${selectedCategory === 'all' ? 'bg-blue-50 text-blue-600 font-bold border-blue-100' : 'text-slate-600 hover:bg-slate-50 hover:border-slate-100'}`}
                        >
                            <Icons.Grid size={18} /> همه محصولات
                        </button>
                        {categories.map(cat => {
                            const DynamicIcon = Icons[cat.icon] || Icons.Box;
                            return (
                                <button
                                    key={cat.id}
                                    onClick={() => { setSelectedCategory(cat.slug); setIsDesktopMenuOpen(false); scrollToModels(); }}
                                    className={`flex items-center gap-3 p-3 rounded-xl transition-all border border-transparent ${selectedCategory === cat.slug ? 'bg-blue-50 text-blue-600 font-bold border-blue-100' : 'text-slate-600 hover:bg-slate-50 hover:border-slate-100'}`}
                                >
                                    <DynamicIcon size={18} /> {cat.label}
                                </button>
                            );
                        })}
                    </div>
                </div>
            </div>

            <div className="flex items-center justify-center gap-6">
                <button onClick={() => handleNavClick('home')} className={getButtonClass('home')}>خانه</button>
                <button onClick={() => scrollToModels()} className={activePage === 'models' ? getButtonClass('models', 'pink') : getButtonClass('inactive')}>آبجکت‌ها</button>
                <button onClick={() => handleNavClick('news')} className={getButtonClass('news', 'purple')}>اخبار و گفتگو</button>
                <button onClick={() => handleNavClick('about')} className={getButtonClass('about', 'amber')}>معرفی ما</button>
            </div>

            <div className="w-72 relative group">
                <input type="text" placeholder="جستجو در محصولات..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') scrollToModels(); }} className="w-full bg-white border border-slate-200 rounded-xl pl-10 pr-4 py-2.5 text-sm font-bold focus:outline-none focus:border-blue-500 focus:shadow-sm transition-all text-slate-700 placeholder:text-slate-400" />
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 group-focus-within:text-blue-500 transition-colors" size={18} />
            </div>

         </div>
      </div>
    </nav>
  );
};

const Hero = () => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const bannerImages = ["/Banner/slide01.png", "/Banner/slide02.png", "/Banner/slide03.png", "/Banner/slide04.png"];
  
    useEffect(() => {
      const timer = setInterval(() => { setCurrentSlide((prev) => (prev + 1) % bannerImages.length); }, 5000);
      return () => clearInterval(timer);
    }, [bannerImages.length]);
  
    return (
      <section className="w-full pt-4 lg:pt-40 pb-8 animate-fadeIn">
          <div className="relative w-full h-[400px] md:h-[550px] overflow-hidden group">
               <div className="absolute inset-0 w-full h-full">
                  {bannerImages.map((img, index) => (
                      <React.Fragment key={index}>
                          <img src={img} alt={`Slide ${index + 1}`} className={`absolute inset-0 w-full h-full object-cover hidden md:block transition-opacity duration-1000 ease-in-out ${index === currentSlide ? 'opacity-100' : 'opacity-0'}`} onError={(e) => { e.target.onerror = null; e.target.src = "https://via.placeholder.com/1920x1080?text=Architecture+Banner"; }} />
                          <img src={img.replace(/(\.[^/.]+)$/, "-m$1")} alt={`Slide ${index + 1} Mobile`} className={`absolute inset-0 w-full h-full object-cover block md:hidden transition-opacity duration-1000 ease-in-out ${index === currentSlide ? 'opacity-100' : 'opacity-0'}`} onError={(e) => { e.target.onerror = null; e.target.src = img; }} />
                      </React.Fragment>
                  ))}
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900/40 via-transparent to-transparent"></div>
              </div>
              <div className="absolute bottom-6 left-0 right-0 flex justify-center gap-2 z-20">
                  {bannerImages.map((_, idx) => (
                  <button key={idx} onClick={(e) => { e.stopPropagation(); setCurrentSlide(idx); }} className={`h-1.5 rounded-full transition-all duration-500 ${idx === currentSlide ? 'bg-white w-8 shadow-[0_0_10px_white]' : 'bg-white/50 w-2 hover:bg-white/80'}`} aria-label={`Go to slide ${idx + 1}`} />
                  ))}
              </div>
          </div>
      </section>
    );
};
  
const AboutSection = () => {
  return (
    <section className="pt-36 pb-20 lg:pt-48 lg:pb-32 bg-white min-h-screen">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16 animate-fade-in-up">
            <h2 className="text-3xl md:text-5xl font-black text-slate-800 mb-6">درباره <span className="text-blue-600">ما</span></h2>
            <div className="w-24 h-1.5 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full mx-auto"></div>
          </div>
          <div className="grid md:grid-cols-2 gap-12 items-center mb-20 animate-fade-in-up delay-100">
            <div className="relative">
                <div className="absolute inset-0 bg-blue-600/10 rounded-3xl transform rotate-3"></div>
                <div className="relative bg-slate-50 rounded-3xl p-8 border border-slate-100 h-full flex flex-col justify-center items-center text-center">
                  <div className="w-24 h-24 bg-white rounded-full flex items-center justify-center shadow-lg mb-6 text-blue-600 overflow-hidden">
                        <img src="/Banner/logo.png" alt="About Logo" className="w-full h-full object-contain p-2" />
                  </div>
                  <h3 className="text-2xl font-bold text-slate-800 mb-2"> </h3>
                  <p className="text-blue-600 font-bold text-sm mb-4">مهندس برزوئی، معمار و طراح ارشد</p>
                  <div className="flex gap-2 justify-center">
                      <span className="bg-white px-3 py-1 rounded-full text-xs font-medium text-slate-500 shadow-sm">10 سال تجربه</span>
                      <span className="bg-white px-3 py-1 rounded-full text-xs font-medium text-slate-500 shadow-sm">متخصص طراحی داخلی</span>
                  </div>
                </div>
            </div>
            <div className="space-y-6 text-justify">
              <p className="text-slate-600 leading-8">با سلام، من مهندس برزوئی در این مجموعه فعالیت می‌کنم. پس از یک دهه فعالیت حرفه‌ای در دفاتر معماری بزرگ و مشارکت در پروژه‌های ساختمانی متعدد، همواره با چالش یافتن منابع باکیفیت و استاندارد برای ارائه طرح‌ها روبرو بودم.</p>
              <p className="text-slate-600 leading-8">تجربه سال‌ها کار با نرم‌افزارهای تخصصی معماری به من آموخت که دسترسی سریع به آبجکت‌ها و متریال‌های صحیح، نه تنها سرعت کار را بالا می‌برد، بلکه کیفیت نهایی رندرها را دگرگون می‌کند.</p>
              <div className="bg-blue-50 border-r-4 border-blue-600 p-6 rounded-l-xl">
                  <p className="text-slate-800 font-medium italic">"هدف من از راه‌اندازی این مجموعه، به اشتراک‌گذاری آرشیوی گزینش‌شده از فایل‌هایی است که در طول سال‌ها تجربه جمع‌آوری کرده‌ام، تا مسیر طراحی را برای همکارانم هموارتر سازم."</p>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 animate-fade-in-up delay-200">
              <div className="bg-slate-50 p-6 rounded-2xl border border-slate-100 hover:border-blue-200 transition-colors">
                  <Briefcase className="text-purple-500 mb-4" size={32} />
                  <h4 className="font-bold text-slate-800 mb-2">تجربه اجرایی</h4>
                  <p className="text-sm text-slate-500 leading-6">درک نیازهای واقعی بازار کار و استانداردهای مورد نیاز برای پروژه‌های اجرایی و فاز دو.</p>
              </div>
              <div className="bg-slate-50 p-6 rounded-2xl border border-slate-100 hover:border-blue-200 transition-colors">
                  <Layers className="text-blue-500 mb-4" size={32} />
                  <h4 className="font-bold text-slate-800 mb-2">آرشیو استاندارد</h4>
                  <p className="text-sm text-slate-500 leading-6">بررسی تک تک فایل‌ها از نظر متریال‌دهی صحیح و سبک بودن پلیگان‌ها برای رندرهای سنگین.</p>
              </div>
              <div className="bg-slate-50 p-6 rounded-2xl border border-slate-100 hover:border-blue-200 transition-colors">
                  <Coffee className="text-amber-500 mb-4" size={32} />
                  <h4 className="font-bold text-slate-800 mb-2">برای معماران</h4>
                  <p className="text-sm text-slate-500 leading-6">فضایی تخصصی که با زبان معماران آشناست و دغدغه‌های زمان تحویل پروژه را درک می‌کند.</p>
              </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const App = () => {
  const [activePage, setActivePage] = useState('home');
  const [selectedProduct, setSelectedProduct] = useState(null); 
  const [isAuthOpen, setIsAuthOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isUserProfileOpen, setIsUserProfileOpen] = useState(false); 
  
  // استیت‌های جستجو و دسته‌بندی
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  
  // استیت‌های دسته‌بندی داینامیک و احراز هویت
  const [categories, setCategories] = useState([]);
  const [user, setUser] = useState(null);

  // دریافت دسته‌بندی‌ها از دیتابیس
  useEffect(() => {
    axios.get('https://free3dmax.ir/api/categories.php')
      .then(res => {
        if (Array.isArray(res.data)) {
          setCategories(res.data);
        }
      })
      .catch(err => console.error("Error fetching categories:", err));
  }, []);

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const pageParam = searchParams.get('page');

    if (pageParam === 'admin-panel') {
       setActivePage('admin');
    }

    const storedUser = localStorage.getItem('user');
    if (storedUser) setUser(JSON.parse(storedUser));

    if (!window.history.state) {
        if (pageParam === 'admin-panel') {
            window.history.replaceState({ page: 'admin' }, '');
        } else {
            window.history.replaceState({ page: 'home' }, '');
        }
    }

    const handlePopState = (event) => {
        if (event.state && event.state.page) {
            setActivePage(event.state.page);
            if(event.state.page !== 'product-detail') setSelectedProduct(null);
        } else {
            setActivePage('home');
        }
    };

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [activePage]);

  const handleNavigation = (page) => {
      setActivePage(page);
      setSelectedProduct(null); 
      if (page !== 'admin') {
         window.history.pushState({ page }, '', page === 'home' ? '/' : `#${page}`);
      } else {
         window.history.pushState({ page }, '', '/?page=admin-panel');
      }
  };

  const handleProductSelect = (product) => {
      setSelectedProduct(product);
      setActivePage('product-detail');
      window.scrollTo({ top: 0, behavior: 'smooth' });
      window.history.pushState({ page: 'product-detail' }, '', `#product-${product.id}`);
  };

  const handleBackToProducts = () => {
      setActivePage('home');
      setSelectedProduct(null);
      setTimeout(() => { handleScrollToModels(); }, 100);
      window.history.pushState({ page: 'home' }, '', '/');
  };

  const handleScrollToModels = () => {
      if (activePage !== 'home') handleNavigation('home');
      setTimeout(() => {
          const el = document.getElementById('main-content');
          if(el) {
              const yOffset = -120;
              const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
              window.scrollTo({ top: y, behavior: 'smooth' });
          }
      }, 100);
  };

  const handleLoginSuccess = (userData) => {
    setUser(userData);
    localStorage.setItem('user', JSON.stringify(userData)); 
  };

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem('user');
  };

  const renderContent = () => {
    if (activePage === 'about') return <AboutSection />;
    if (activePage === 'news') return <NewsAndReviews currentUser={user} />;
    if (activePage === 'product-detail' && selectedProduct) return <ProductDetail product={selectedProduct} onBack={handleBackToProducts} />;

    return (
        <>
           <Hero />
           <MainContent 
             categories={categories}
             onProductSelect={handleProductSelect}
             selectedCategory={selectedCategory}
             setSelectedCategory={setSelectedCategory}
             searchQuery={searchQuery}
             setSearchQuery={setSearchQuery} 
           /> 
        </>
    );
  };

  return (
    <div dir="rtl" className="font-sans text-slate-800 antialiased selection:bg-blue-200 selection:text-blue-900 bg-slate-50 min-h-screen flex flex-col">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Vazirmatn:wght@100;300;400;500;700;900&display=swap');
        body { font-family: 'Vazirmatn', sans-serif; }
        .custom-scrollbar::-webkit-scrollbar { height: 6px; width: 6px; }
        .custom-scrollbar::-webkit-scrollbar-track { background: #f1f5f9; }
        .custom-scrollbar::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 3px; }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover { background: #94a3b8; }
        .animate-fade-in-up { animation: fadeInUp 0.8s cubic-bezier(0.16, 1, 0.3, 1) forwards; opacity: 0; transform: translateY(20px); }
        .delay-100 { animation-delay: 0.1s; }
        .delay-200 { animation-delay: 0.2s; }
        .delay-300 { animation-delay: 0.3s; }
        @keyframes fadeInUp { to { opacity: 1; transform: translateY(0); } }
      `}</style>

      {activePage !== 'admin' && (
        <>
          <Navbar 
            categories={categories}
            onOpenAuth={() => setIsAuthOpen(true)} 
            activePage={activePage} 
            onNavigate={handleNavigation} 
            setMobileMenuOpen={setMobileMenuOpen}
            scrollToModels={handleScrollToModels}
            user={user}
            onOpenUserProfile={() => setIsUserProfileOpen(true)}
            selectedCategory={selectedCategory}
            setSelectedCategory={setSelectedCategory}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
          />
          
          <MobileMenu 
            isOpen={mobileMenuOpen}
            onClose={() => setMobileMenuOpen(false)}
            activePage={activePage}
            onNavigate={handleNavigation}
            onOpenAuth={() => setIsAuthOpen(true)}
            scrollToModels={handleScrollToModels}
            user={user}
            onOpenUserProfile={() => setIsUserProfileOpen(true)}
          />
        </>
      )}

      <main className={`flex-grow ${activePage !== 'admin' ? 'pt-[120px] lg:pt-[10px]' : ''}`}> 
         {activePage === 'admin' ? (
             <AdminPanel onBack={() => handleNavigation('home')} />
         ) : (
             renderContent()
         )}
      </main>

      {activePage !== 'admin' && <Footer />}

      <Login isOpen={isAuthOpen} onClose={() => setIsAuthOpen(false)} onLoginSuccess={handleLoginSuccess} />
      <UserProfileModal isOpen={isUserProfileOpen} onClose={() => setIsUserProfileOpen(false)} user={user} onLogout={handleLogout} />
    </div>
  );
};

export default App;